import React from "react";
import WelcomeScreen from "../clientSettings/tabs/welcomeScreen";



export const WelcomePanner = (props) => {
    return (
        <WelcomeScreen {...props} />
    )
}